import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PreventiveRecallListSettingsContainerState } from "@/Portfolio/Components/PreventiveRecallListSettingsContainer";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class PreventiveRecallListSettingsContainerHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Portfolio.PreventiveRecallList_SearchSettings_ColumnOrderingPopup_Visibility, this.toggleColumnOrderingPopupVisibility);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveRecallList_SearchSettings_Container_Visibility, this.toggleSearchSettingsPopupVisibility);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveRecallList_SearchSettings_Load, this.loadPreventiveRecallListSearchSettings);
        this.RegisterOperation(LocalOperations.Portfolio.PreventiveRecallList_PreventiveCareCriteria_Visibility, this.togglePreventiveCareCriteriaPopupVisibility);
    }

    private toggleColumnOrderingPopupVisibility(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = request.Get<boolean>("isOpen");
        store.preventiveRecallListModel = store.preventiveRecallListModel
            .set("IsColumnOrderingPopupOpen", isOpen)
            .set("IsSettingsContainerOpen", false);
    }

    private toggleSearchSettingsPopupVisibility(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = request.Get<boolean>("isOpen");
        store.preventiveRecallListModel = store.preventiveRecallListModel.set("IsSettingsContainerOpen", isOpen);
    }

    private togglePreventiveCareCriteriaPopupVisibility(request: LocalEvent, store: PortfolioStore): void {
        const isOpen = request.Get<boolean>("isOpen");

        store.preventiveRecallListModel = store.preventiveRecallListModel
            .set("IsPreventiveCareCriteriaPopupOpen", isOpen)
            .set("IsSettingsContainerOpen", false);
    }

    private loadPreventiveRecallListSearchSettings(request: LocalEvent, store: PortfolioStore): void {
        const settings = request.Get<PreventiveRecallListSettingsContainerState>("settings");
        store.preventiveRecallListModel = store.preventiveRecallListModel
            .set("SavedSettingsContainerState", settings)
            .set("CurrentPage", 1)
            .set("IsSettingsContainerOpen", false);

        portfolioStore.PortfolioActions.loadPreventiveRecallList();
    }
}

export { PreventiveRecallListSettingsContainerHandler };
